module.exports = __webpack_public_path__ + "static/media/ic_player_settings.b5052858.svg";